<template>
  <div>
	<h1>メンバー</h1>
	<h2>教員</h2>
	<div>教授: 福士　将<a target="_blank" href="http://www.csse.yamaguchi-u.ac.jp/staff/fukushi.html">(詳細は教員ページにて)</a></div>

	<div>講師: 黒川　陽太</div>
	<div>助教: 猪原　圭一</div>	

	<h2>博士課程</h2>
	<h3>D3（社会人学生）</h3>
	<div>千田　益護</div>
	<h3>D2</h3>
	<div>孫　致鼎</div>


	<h2>修士課程</h2>
	<h3>M2</h3>

	<h4>指導教員: 福士　将</h4>
	<div>一垣　舜也</div>
	<div>廣重　将輝</div>
	<div>本田　篤宏</div>
	<div>MA HE</div>
	<div>ZHANG ZHIHENG</div>

	<h4>指導教員: 黒川　陽太</h4>
	<div>河田　直輝</div>

	<h3>M1</h3>

	<h4>指導教員: 福士　将</h4>
	<div>金﨑　塁</div>
	<div>小林　奏也</div>
	<div>中尾　崇人</div>
	<div>中尾　勇翔</div>
	<div>三栗　大希</div>
	<div>鐘　鈺瀚</div>
	<div>WANG JIAXI</div>

	<h4>指導教員: 黒川　陽太</h4>
	<div>髙橋　凌久</div>

	<h2>学部生</h2>
	<h3>B4</h3>

	<h4>指導教員: 福士　将</h4>
	<div>スサント　マシュー</div>
	<div>岩本　悠斗ー</div>
	<div>吉田　政弘</div>
	<div>大久保　直翔</div>

	<h4>指導教員: 黒川　陽太</h4>
	<div>谷上　竜一</div>
	<div>門脇　弓奈</div>
	<div>黒松　奎汰</div>
	<div>近藤　梨央</div>


	<h2>研究生</h2>
	<h4>指導教員: 福士　将</h4>
	<div>張　卓華</div>

  </div>
</template>

<script>
export default {
  name: 'MemberView',
  props: {
    msg: String
  }
}
</script>

<style scoped>

</style>
